import { useCallback, useEffect, useState } from "react";
import { ISelectOptions } from "../../../types/inputs";
import { useForm, Controller } from "react-hook-form";
import { IItineranteListProps } from "../../../types/itinerante";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Delivery } from "../../../services/Delivery";
import { Itinerante } from "../../../services/Itinerante";

const schema = z.object({
  cidade: z.string().optional(),
  dataRealizacao: z.string().optional(),
  uuidDelivery: z.string().optional(),
});

export const useFormFilterItinerant = () => {
  const [cidadesOptions, setCidadesOptions] = useState<ISelectOptions[]>(
    [] as ISelectOptions[]
  );

  const [unidades, setUnidades] = useState<ISelectOptions[]>(
    [] as ISelectOptions[]
  );
  const [date, setDate] = useState<Date | null>(null);

  const { control, handleSubmit, reset } = useForm<IItineranteListProps>({
    defaultValues: {
      cidade: "",
      dataRealizacao: "",
      uuidDelivery: "",
    },
    resolver: zodResolver(schema),
    mode: "all",
  });

  const getDeliverys = useCallback(() => {
    Delivery.get().then(({ data }) => {
      const options = data.content.map((i) => ({
        label: i.cidade,
        value: i.uuid,
        element: i,
      }));

      setUnidades(options);
    });
  }, []);

  function getCidades(nome?: string) {
    Itinerante.listar_cidades(nome).then(({ data }) => {
      const options = data.map((i) => ({
        label: i,
        value: i,
      }));

      setCidadesOptions(options);
    });
  }

  useEffect(() => {
    getDeliverys();
    getCidades();
  }, []);

  return {
    unidades,
    Controller,
    control,
    handleSubmit,
    reset,
    date,
    setDate,
    cidadesOptions,
    getCidades,
  };
};
